// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".address {\n  padding: 30px;\n}\n.address .el-table .el-input__inner {\n  width: 400px;\n}\n.address .el-table .area-input .el-input__inner {\n  width: 180px;\n}\n.search-container .el-input {\n  width: 200px;\n}\n.search-container .el-select {\n  width: 200px;\n}\n.cell {\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
